// Typed facade over the calendar write endpoints. Only the functions needed by the four call sites
// T2's first slice converts (undo, colour save, workflow transition, note autosave) — see
// docs/plans/t2-bridge-and-context-menu.md section 4. More endpoints are added as their callers convert.
import { getJson, postForm, postJson, request } from "./http-client";

export interface UndoPreviewResult {
  ok: boolean;
  prompt?: string;
  error?: string;
}

export interface UndoExecuteResult {
  ok: boolean;
  error?: string;
}

export function undoPreview(): Promise<UndoPreviewResult> {
  return getJson<UndoPreviewResult>("undo_preview.php");
}

export async function executeUndo(): Promise<UndoExecuteResult> {
  const response = await request("undo.php", { method: "POST" });
  return (await response.json()) as UndoExecuteResult;
}

export interface SaveColorResult {
  success: boolean;
}

export function saveEventColor(eventId: string, colorHex: string, textColorHex: string): Promise<SaveColorResult> {
  const form = new FormData();
  form.append("eventId", eventId);
  form.append("color_hex", colorHex);
  form.append("text_color_hex", textColorHex);
  return postForm<SaveColorResult>("user_event_color_save.php", form);
}

export interface TransitionPayload {
  ID_event: number;
  ID_workflow_type: number;
  ID_user: number | null;
  to_state: string;
}

export interface TransitionResult {
  ok: boolean;
  error?: string;
  label?: string;
  color?: string;
}

export function transitionEventState(payload: TransitionPayload): Promise<TransitionResult> {
  return postJson<TransitionResult>("update_event_state.php", payload);
}

export interface SaveNoteResult {
  success: boolean;
}

// Token travels in the FormData body here (not a header) to match the existing endpoint contract.
export function saveEventNote(eventId: string, note: string, csrfToken: string): Promise<SaveNoteResult> {
  const form = new FormData();
  form.append("eventId", eventId);
  form.append("note", note);
  form.append("csrf_token", csrfToken);
  // keepalive so the blur-triggered save survives the Save click navigating away; skipped for a note too big for its 64 KiB cap
  const keepalive = new Blob([note]).size < 60_000;
  return postForm<SaveNoteResult>("user_event_note_save.php", form, { keepalive });
}
